export default {
	productID: 'webPlatform',
	// -------------图表上显示的logo名称---------------
	canvasText: '', //北京育见未来
	// ---------------是否显示育见logo--------------
	logo: true,
	openFooter: false, //页尾是否显示
	//------------------ 系统名称------------------
	sysID: 0,
	sysName: '数智化医康养课程管理平台',
	// assessmentType: '2', //老年人能力评估
	// -------------------系统版本-----------------------
	version: 'v1.3.0',
	SimQueuingNumber: 100, //仿真实验-超出人数开始排队
	showCourseCreateTime: true, //是否显示 课程列表-创建时间
	YJWLToolAssistantAddress: { url: '/file/YJWLToolAssistantV2.exe', name: 'YJWLToolAssistantV2.exe' }, //插件下载地址
	webglCache: true, //true 默认，false 添加随机数，不要浏览器缓存

	identifyCodeUser: true, //登录 验证码功能
	toolModel: true, //是否开启工具库模块
	faceLogin: true,//是否开启人脸识别登录
	courseAudit: true,//是否开启课程审核功能
	questionBankAuth: true,//是否开放题库对教师授权（校级管理员）
	helpDocShow: true,//是否显示帮助文档
	isMirrorVersion: false, //是否是镜像版（true时编辑删除权限开放给所有用户）
	
	//线上版本
	baseURL: 'https://eduapi.yjwledu.cn/',
	fileurl: 'https://eduapi.yjwledu.cn',
	ssoServers: 'https://edu.yjwledu.cn',
	locationOrigin: 'https://edu.yjwledu.cn',

	//本地测试
	// baseURL: 'http://localhost:44356/',
	// fileurl: 'http://localhost:44356',
	// ssoServers: 'http://localhost:8080',
	// locationOrigin: 'http://localhost:8080',

	//供货版本
	// toolModel: false, //是否开启工具库模块
	// isMirrorVersion: true, //镜像版
	// baseURL: 'http://192.168.1.3:81/',
	// fileurl: 'http://192.168.1.3:81',
	// ssoServers: 'http://192.168.1.3:82',
	// locationOrigin: 'http://192.168.1.3:82',
}